import { render, staticRenderFns } from "./MemberNiscc.vue?vue&type=template&id=0194a091"
import script from "./MemberNiscc.vue?vue&type=script&lang=js"
export * from "./MemberNiscc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports